import Style from "./Footer.module.css";
function Footer() {
  return (
    <>
      <div className="d-flex justify-content-center py-4 bg-dark text-white ">
        <h6 className="fs-3 fw-bold">Footer</h6>
      </div>
    </>
  );
}

export default Footer;
